import React, { useState } from 'react';

import Swal from 'sweetalert2';

import { useNavigate } from 'react-router-dom';

function Menu({
  onBackToWelcome,
}) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] =  useState(false);
  const selectedKustomer = localStorage.getItem('selectedPostTitle');
  const usherName = localStorage.getItem('name');

  const handleLogout = () => {
    Swal.fire({
      title: 'Logout Sekarang?',
      showCancelButton: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();

        navigate('/login');
      }

      setMenuOpen(false);
    });
  };

  return (
    <div className="menu_wrap logout_wrap">
    <svg
     xmlns="http://www.w3.org/2000/svg"
     width="32"
     height="32"
     viewBox="0 0 24 24"
     fill="#fff"
     onClick={() => setMenuOpen((prev) => !prev)}
     style={{ cursor: 'pointer' }}
    >
     <path
      d="M3 6h18M3 12h18M3 18h18"
      stroke="#928c8c"
      strokeWidth="2"
      strokeLinecap="round"
     />
    </svg>

    {menuOpen && (
     <div className="dropdown-menu">     
       <div>
        <div className="dropdown-item">
         <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#333"
         >
          <path
           d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
             2 6 4 4 6.5 4c1.74 0 3.41 1.01 4.13 2.44h.74C14.09 5.01 15.76 4 17.5 4 
             20 4 22 6 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          />
         </svg>
         {selectedKustomer}
        </div>
        <div className="dropdown-item">
         <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          viewBox="0 0 24 24"
         >
          <path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-3.3 0-10 1.7-10 5v3h20v-3c0-3.3-6.7-5-10-5z" />
         </svg>
         {usherName}
        </div>
        <div style={{ borderBottom: '1px solid #ccc' }}></div>   

        <div
         onClick={() => {
            navigate('/dashboard');
            setMenuOpen(false);
         }}
         className="dropdown-item"
        >
         <svg width="24" height="24" viewBox="0 0 24 24" fill="#333">
          <path d="M12 3 2 12h3v8h6v-5h2v5h6v-8h3L12 3z" />
         </svg>
         Dashboard
        </div>

        <div
         onClick={() => {
            navigate('/tamu');
            setMenuOpen(false);
         }}
         className="dropdown-item"
        >
         <svg width="24" height="24" viewBox="0 0 24 24" fill="#333">
          <path d="M16 11a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm-8 0a3 3 0 1 0-3-3 3 3 0 0 0 3 3zm0 2c-2.3 0-7 1.2-7 3.5V19h8v-2.5c0-.9.5-1.7 1.3-2.4A12 12 0 0 0 8 13zm8 0c-.5 0-1.1 0-1.7.1.9.7 1.7 1.6 1.7 2.9V19h7v-2.5c0-2.3-4.7-3.5-7-3.5z" />
         </svg>
         Tamu / Riwayat Check-in
        </div>

        <div
         onClick={() => {
            onBackToWelcome();
            setMenuOpen(false);
         }}
         className="dropdown-item"
        >
         <svg width="24" height="24" viewBox="0 0 24 24" fill="#333">
          <path d="M3 4h13v10H3zM1 16h17v2H1zm18-9h4v11h-4z" />
         </svg>
         Layar Sapa
        </div>
       </div>
      

      <div onClick={handleLogout} className="dropdown-item">
       <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 512 512"
        fill="#333"
       >
        <path d="M256 0c-17.673 0-32 14.327-32 32v192c0 17.673 14.327 32 32 32s32-14.327 32-32V32c0-17.673-14.327-32-32-32zM388.707 97.293c-12.497-12.497-32.758-12.497-45.255 0-12.497 12.497-12.497 32.758 0 45.255C373.882 173.979 400 221.747 400 272c0 79.529-64.471 144-144 144S112 351.529 112 272c0-50.253 26.118-98.021 56.548-129.452 12.497-12.497 12.497-32.758 0-45.255-12.497-12.497-32.758-12.497-45.255 0C78.41 143.71 48 204.504 48 272c0 114.875 93.125 208 208 208s208-93.125 208-208c0-67.496-30.41-128.29-75.293-174.707z" />
       </svg>
       Logout
      </div>
     </div>
    )}
   </div>
  );
}

export default Menu;